<template>
  <v-app>
    <notifications ref="notification" />

    <pages-core-view />

    <pages-core-footer />
  </v-app>
</template>

<script>
export default {
  name: "PagesIndex",
  components: {
    PagesCoreFooter: () => import("./components/core/Footer"),
    PagesCoreView: () => import("./components/core/FrontendView.vue")
  },

  created() {
    this.$vuetify.theme.dark = false;
  },

  beforeDestroy() {
    this.$vuetify.theme.dark = false;
  }
};
</script>
